import { commonjsGlobal as h } from "./index135.mjs";
import { __module as x } from "./index171.mjs";
x.exports;
(function(p) {
  (function(l, f, m) {
    function s(r) {
      var t = this, o = "";
      t.next = function() {
        var n = t.b, e = t.c, i = t.d, c = t.a;
        return n = n << 25 ^ n >>> 7 ^ e, e = e - i | 0, i = i << 24 ^ i >>> 8 ^ c, c = c - n | 0, t.b = n = n << 20 ^ n >>> 12 ^ e, t.c = e = e - i | 0, t.d = i << 16 ^ e >>> 16 ^ c, t.a = c - n | 0;
      }, t.a = 0, t.b = 0, t.c = -1640531527, t.d = 1367130551, r === Math.floor(r) ? (t.a = r / 4294967296 | 0, t.b = r | 0) : o += r;
      for (var a = 0; a < o.length + 20; a++)
        t.b ^= o.charCodeAt(a) | 0, t.next();
    }
    function u(r, t) {
      return t.a = r.a, t.b = r.b, t.c = r.c, t.d = r.d, t;
    }
    function b(r, t) {
      var o = new s(r), a = t && t.state, n = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return n.double = function() {
        do
          var e = o.next() >>> 11, i = (o.next() >>> 0) / 4294967296, c = (e + i) / (1 << 21);
        while (c === 0);
        return c;
      }, n.int32 = o.next, n.quick = n, a && (typeof a == "object" && u(a, o), n.state = function() {
        return u(o, {});
      }), n;
    }
    f && f.exports ? f.exports = b : this.tychei = b;
  })(
    h,
    p
  );
})(x);
var y = x.exports;
export {
  y as t
};
